import { useEffect, useState } from "react"
import { Apis } from "../../helpers"

export type AccessRole = 'super' | 'admin' | 'user'

// The signed-in user's role, asked of the server rather than read from the stored user: it changes when the super admin
// grants or removes admin, and the stored user is only refreshed at sign-in. Null until the server has answered.
const useAccessRole = (): AccessRole | null => {
    const [role, setRole] = useState<AccessRole | null>(null)

    useEffect(() => {
        let active = true
        Apis({ module: 'Locks', action: 'getMyRole' })
            .then((resp: any) => { if (active && resp?.role) setRole(resp.role) })
            .catch(() => undefined)
        return () => { active = false }
    }, [])

    return role
}

export default useAccessRole
